import React, { forwardRef, useEffect, useRef } from "react";

const CustomCheckboxNew = forwardRef(
  (
    {
      id,
      name,
      checked = false,
      indeterminate = false,
      onChange,
      label,
      disabled = false,
      className = "",
      ...props
    },
    ref
  ) => {
    const checkboxRef = useRef(null);
    const actualRef = ref || checkboxRef;

    useEffect(() => {
      if (actualRef.current) {
        actualRef.current.indeterminate = indeterminate;
      }
    }, [indeterminate, actualRef]);

    return (
      <div className={`flex items-center ${className}`}>
        <div className="relative">
          <input
            type="checkbox"
            id={id}
            name={name}
            ref={actualRef}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="sr-only" // Hide the actual checkbox but keep it accessible
            {...props}
          />
          <label
            htmlFor={id}
            className={`flex items-center cursor-pointer ${
              disabled ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            <div
              className={`
            flex items-center justify-center w-[14px] h-[14px] border-[1px] rounded-sm 
            transition-colors duration-200 ease-in-out
            ${
              checked && !indeterminate
                ? "bg-primary border-primary"
                : "bg-white border-gray-300"
            } 
            ${disabled ? "opacity-60" : ""}
            ${!checked && !indeterminate ? "hover:border-primary" : ""}
            focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-300
          `}
            >
              {checked && !indeterminate && (
                <svg
                  className="w-3.5 h-3.5 text-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                    fill="currentColor"
                  />
                </svg>
              )}
              {indeterminate && (
                <svg
                  className="w-3.5 h-3.5 text-primary"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M19 13H5v-2h14v2z" fill="currentColor" />
                </svg>
              )}
            </div>
            {label && <span className="text-sm ml-1">{label}</span>}
          </label>
        </div>
      </div>
    );
  }
);

CustomCheckboxNew.displayName = "CustomCheckboxNew";

export default CustomCheckboxNew;
